import { useStateValue } from '../../context/StateValueContext';
import { PERMISSIONS } from '../../constants/permissions';
import AdminRdrNotices from './RdrNotices';
import ClientRdrNotices from '../ClientAlerts/ClientRdrNotices';

export default function RdrSwitcher() {
  const [{ user }] = useStateValue();

  if (user?.permissions?.includes(PERMISSIONS.ALERTS_ALL)) {
    return <AdminRdrNotices />;
  }

  return <ClientRdrNotices />;
}
